import React from 'react';
import { motion } from 'framer-motion';
interface CommissionRow {
  rent: number;
  commission: number;
  vat: number;
  total: number;
}
const commissionData: CommissionRow[] = [{
  rent: 400,
  commission: 200,
  vat: 42,
  total: 242
}, {
  rent: 500,
  commission: 250,
  vat: 52.5,
  total: 302.5
}, {
  rent: 700,
  commission: 350,
  vat: 73.5,
  total: 423.5
}, {
  rent: 1000,
  commission: 500,
  vat: 105,
  total: 605
}];
export function CommissionTable() {
  return <div className="overflow-x-auto" data-id="element-647">
      <table className="w-full bg-white rounded-xl overflow-hidden shadow-md" data-id="element-648">
        <thead className="bg-gradient-to-r from-[#357BEB] to-[#2868d8] text-white" data-id="element-649">
          <tr data-id="element-650">
            <th className="px-6 py-4 text-left text-sm font-bold" data-id="element-651">
              Chirie lunară (€)
            </th>
            <th className="px-6 py-4 text-left text-sm font-bold" data-id="element-652">
              Comision fără TVA (€)
            </th>
            <th className="px-6 py-4 text-left text-sm font-bold" data-id="element-653">
              TVA (21%) (€)
            </th>
            <th className="px-6 py-4 text-left text-sm font-bold" data-id="element-654">
              Total comision (€)
            </th>
          </tr>
        </thead>
        <tbody data-id="element-655">
          {commissionData.map((row, index) => <motion.tr key={row.rent} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.1
        }} className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-blue-50 transition-colors`} data-id="element-656">
              <td className="px-6 py-4 text-[#132C53] font-semibold" data-id="element-657">
                {row.rent} €
              </td>
              <td className="px-6 py-4 text-gray-700" data-id="element-658">{row.commission} €</td>
              <td className="px-6 py-4 text-gray-700" data-id="element-659">{row.vat} €</td>
              <td className="px-6 py-4 text-[#357BEB] font-bold" data-id="element-660">
                {row.total} €
              </td>
            </motion.tr>)}
        </tbody>
      </table>
    </div>;
}